import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store';

const useWidthGant = () => {
    const widthLeftHeader = useSelector<RootState, number>((state) => state.gant.widthLeftHeader);
    const availableWidth = useSelector<RootState, number>((state) => state.gant.availableWidth);

    return useMemo(() => availableWidth - widthLeftHeader, [availableWidth, widthLeftHeader]);
};

export default useWidthGant;
